<template>
  <section class="visual-data-section">
    <img
      v-if="useTextureBackground"
      class="visual-data-section-texture"
      src="@/assets/texture-2.png"
    />
    <div
      class="section-header"
      data-aos="fade-right"
      data-aos-offset="300"
    >
      <div class="flex-container">
        <div class="header-text-wrap">
          <h3
            v-if="title"
            v-html="title"
          ></h3>
          <slot v-else name="header" />
          <p v-if="subtext" v-text="subtext"></p>
        </div>
      </div>
    </div>
    <div
      class="section-content"
      data-aos="fade-left"
      data-aos-offset="300"
    >
      <slot/>
    </div>
  </section>
</template>

<script>
export default {
  name: 'VisualDataSection',
  props: {
    title: String,
    subtext: String,
    useTextureBackground: Boolean,
  },
};
</script>
